<template>
  <div 
    @mousedown.left.prevent="onMouseDown"
    @mousemove="onMouseMove"
    @mouseup="onMouseUp"
  >
    <img
      style="display: block; width: 100%;"
      ref="img"
      :src="src">
    <FbPictureTag
      v-for="(tag, i) in pictureTags"
      :key="i"
      :tag="tag"
      :edit-mode="editMode"
      :size-ratio="sizeRatio"
      @delete="deleteTag" />
  </div>
</template>

<script>
import FbPictureTag from '../components/FbPictureTag'

const MIN_TAG_SIZE = 25

export default {
  name: 'FbPicture',
  components: {
    FbPictureTag
  },
  props: {
    src: String,
    tags: Array,
    tagMode: Boolean,
    editMode: Boolean
  },
  data() {
    return {
      newTag: null,
      sizeRatio: undefined
    }
  },
  mounted() {
    this.$nextTick(() => this.updateSizeRatio())
    window.addEventListener('resize', this.updateSizeRatio)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateSizeRatio)
  },
  computed: {
    pictureTags() {
      if (!this.sizeRatio)
        return []
      if (this.tagMode)
        return this.newTag ? [this.newTag] : []
      return this.tags || []
    }
  },
  methods: {
    deleteTag(tag) {
      this.tags = this.tags.filter(t => t !== tag)
      this.$emit('delete', tag)
    },
    updateSizeRatio() {
      const img = this.$refs.img
      const { width, height } = img.getBoundingClientRect()
      this.sizeRatio = {
        x: width / img.naturalWidth,
        y: height / img.naturalHeight
      }
    },
    getRelativeMousePosition(e) {
      const img = this.$refs.img
      const { top, left } = img.getBoundingClientRect()
      return {
        x: e.clientX - left,
        y: e.clientY - top
      }
    },
    onMouseDown(e) {
      if (!this.tagMode)
        return
      this.updateSizeRatio()
      const { x, y } = this.getRelativeMousePosition(e)
      this.newTag = { 
        x: x / this.sizeRatio.x, 
        y: y / this.sizeRatio.y, 
        size: MIN_TAG_SIZE / this.sizeRatio.x
      }
    },
    onMouseMove(e) {
      if (!this.tagMode || !this.newTag)
        return
      const { x, y } = this.getRelativeMousePosition(e)
      this.newTag.size = Math.abs(
        Math.max(
          x - this.newTag.x * this.sizeRatio.x, 
          y - this.newTag.y * this.sizeRatio.y,
          MIN_TAG_SIZE
        )
      ) / this.sizeRatio.x
    },
    onMouseUp() {
      if (!this.tagMode || !this.newTag)
        return
      console.log(this.newTag)
      this.$emit('tag', this.newTag)
      this.newTag = null
    }
  }
}
</script>